import React from 'react';

import { TabGroup } from '@dutchie/backoffice-ui-library';
import { useParams } from 'react-router-dom';

import { ROUTES } from 'src/apps/brand-connect/routes';

import { Heading, Page } from '../shared/styled';

import { BrandCatalog } from './brand-catalog';
import { Insights } from './insights';
import { TabGroupContainer } from './styled';

export const BRAND_DETAIL_GROUP_ID = 'brand-detail';

export const BRAND_DETAIL_TAB_LABELS = {
  insights: 'Insights',
  brandCatalog: 'Brand catalog',
};

export const BrandDetail = () => {
  const { brandId } = useParams();
  // TODO: get brand data from API

  return (
    <Page gap="var(--sizes-70)">
      <Heading
        showBackButton
        previousRoute={ROUTES.BRANDS}
        subheader={'coming soon'}
      >
        Brand name goes here for brand with id {brandId}
      </Heading>
      <TabGroupContainer>
        <TabGroup
          groupId={BRAND_DETAIL_GROUP_ID}
          tabs={[
            { label: BRAND_DETAIL_TAB_LABELS.insights, content: <Insights /> },
            {
              label: BRAND_DETAIL_TAB_LABELS.brandCatalog,
              content: <BrandCatalog />,
            },
          ]}
        />
      </TabGroupContainer>
    </Page>
  );
};
